// "Wat past bij ons gezin" in de lijsten (0024_keukens_en_labels, builder B; docs/DESIGN.md
// §8.P.5-§8.P.7): teksten rond gefilterde catalogi, eetmeldingen, "Wie eet mee?", de
// weekmenu-voorstellen en de keukenfilter. De redenen zelf staan in profileApp.nl.ts
// (`appText.profile.hidden.*`, `appText.profile.warning.*`). Alleen de webapp; de kiosk krijgt
// alleen de zichtbare lijst. Je-vorm, rustig, geen uitroeptekens, nooit "omdat jullie Turks zijn".
export const appCultureNl = {
    hidden: {
        /** Kop bij de groep na "Geen geloof". */
        groupFaithNone: 'Verborgen omdat jullie bij geloof Geen geloof kozen',
        /** Onder een verborgen zoektreffer: een verborgen optie kiezen mag gewoon. */
        searchHidden: 'Verborgen opties',
    },
    kitchens: {
        filterLabel: 'Keuken',
        all: 'Alle keukens',
    },
    menu: {
        suggestionsTitle: 'Voorstellen voor deze week',
        suggestionsHint: 'Tik op een voorstel en kies een dag.',
        noSuggestions: 'Geen voorstellen meer voor deze week.',
        whoEats: 'Wie eet mee?',
        everyoneEats: 'Iedereen eet mee',
        notEating: '{names} eet niet mee',
        markerLabel: 'Let op bij dit gerecht: {text}',
        chooseDay: 'Kies een dag voor {title}',
    },
    warning: {
        title: 'Past dit bij iedereen?',
        swapped: 'Geruild: {swap} in plaats van {ingredient}.',
        eatsOtherSaved: 'Onthouden: {name} eet iets anders bij dit gerecht.',
        added: 'Toegevoegd.',
    },
    recipes: {
        /** Naam in de eigen keuken onder de titel ("Mercimek çorbası"). */
        original: '{name}',
    },
};
//# sourceMappingURL=cultureApp.nl.js.map